
























import { Component, Prop, Vue } from "vue-property-decorator";
import api from "../../api";
import store from "../../store";
import GuvTableItem from "@/components/common/GuvTableItem.vue";
import { Months } from "../../consts";

@Component({ components: { GuvTableItem } })
export default class GuvTable extends Vue {
  @Prop() data!: any;
  months = Months;

  constructor() {
    super();
  }
}
